import { Box, Chip, Typography } from '@mui/material';
import type { TFunction } from 'i18next';
import LogbookActions from '../components/LogbookListActions';
import type { RowActionAccess } from '../../../components/TableActions';
import type { Column } from '../../../core-components/theme/components/Table/Table';
import { Logbook } from '../types/listTypes';

export const columns = (
  currentQueryKey: any,
  t: TFunction,
  rowAccess: RowActionAccess,
  prefetchLogbookDetails?: (row: Logbook) => void
): Column<Logbook>[] => [
    {
      field: 'name',
      headerName: t('logbook.templates.columns.logbookDetails', 'Logbook Details'),
      align: 'left' as const,
      width: '60%',
      renderCell: (value: string, row: Logbook) => (
        <Box>
          <Typography variant="body1" fontWeight="bold" sx={{ marginBottom: '2px' }}>
            {row.logbookTemplateName || t('logbook.templates.columns.noName', 'No Name')}
          </Typography>
          <Typography variant="body2" >
            {row.logbookTemplateDescription}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'type',
      headerName: t('logbook.templates.form.type', 'Type'),
      align: 'center',
      renderCell: (value: string, row: Logbook) => {
        const chipColor = value === 'Logbook' ? 'primary' : 'success';
        return (
          <Chip
            label={row.type.label}
            color={chipColor}
            variant="outlined"
          />
        );
      },
    },
    {
      field: 'action',
      headerName: t('table.actions', 'Actions'),
      align: 'center',
      renderCell: (value: string, row: Logbook) => {
        return (
          <LogbookActions
            row={row}
            queryKey={currentQueryKey}
            onEditHover={prefetchLogbookDetails}
            canEdit={rowAccess.canEdit}
            canDelete={rowAccess.canDelete}
          />
        );
      },
    },
  ];